export default "__VITE_ASSET__CiG3z5ac__"